import { useEffect, useCallback } from 'react'

export const useBankAccountEvents = (eventNames, onAccountUpdate) => {
  const handleBankAccountEvent = useCallback((event) => {
    if (eventNames.includes(event.data)) {
      onAccountUpdate()
    }
  }, [eventNames, onAccountUpdate])

  useEffect(() => {
    window.addEventListener('message', handleBankAccountEvent)
    return () => {
      window.removeEventListener('message', handleBankAccountEvent)
    }
  }, [handleBankAccountEvent])
}